<template>
    <v-col cols="12" md="6">
        <div class="text-right">
            <v-btn text small color="error" @click="handleDeleteButtonClick">Delete service</v-btn>
        </div>
        <service-form :service="serviceFormData('update')"
                      context="update"
                      @validation-changed="handleFormValidationChanged"/>
        <div class="text-right">
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!saveButtonActive" @click="handleSaveButtonClick"
                   :loading="progress('updateClient')">
                Save
            </v-btn>
            <v-btn @click="handleCancelButtonClick">
                Cancel
            </v-btn>
        </div>
        <confirm ref="delete-confirm"></confirm>
    </v-col>
</template>

<script>
    import Confirm from '../../Common/Confirm'
    import {mapActions, mapState, mapGetters} from 'vuex'
    import ServiceForm from '../Components/ServiceForm'

    export default {
        name: 'UpdateService',
        props: {
            service: Object
        },
        components: {
            ServiceForm,
            Confirm
        },
        computed: {
            ...mapGetters('services', {
                progress: 'progress',
                serviceFormData: 'serviceFormData',
                isServiceFormValid: 'isServiceFormValid'
            }),
            saveButtonActive () {
                return this.isServiceFormValid('update') && !this.progress('updateService')
            }
        },
        mounted() {
            this.initUpdateServiceFormData(this.service.id)
        },
        methods: {
            ...mapActions('services', {
                updateService: 'updateService',
                initUpdateServiceFormData: 'initUpdateServiceFormData',
                changeServiceFormValidation: 'changeServiceFormValidation',
                resetServiceFormData: 'resetServiceFormData',
                deleteService: 'deleteService'
            }),
            async handleSaveButtonClick () {
                const updateResult = await this.updateService()

                if (!updateResult) {
                    return
                }

                this.resetServiceFormData()
                this.$router.push('/services')
            },
            async handleDeleteButtonClick () {
                this.$refs['delete-confirm'].open('Delete service', `Do you want to delete service: "${this.service.title}"?`, {width: 600}).then(async (confirm) => {
                    if (!confirm) {
                        return
                    }

                    try {
                        await this.deleteService(this.service)
                        this.$router.push('/services')
                    } catch (e) {
                        console.log(e)
                    }
                })
            },
            handleCancelButtonClick () {
                this.resetServiceFormData()
                this.$router.push('/services')
            },
            handleFormValidationChanged (value) {
                this.changeServiceFormValidation(value)
            }
        }
    }
</script>

<style scoped>

</style>